import type { AxiosError } from 'axios';
import { isNil } from 'lodash';
import * as documentService from 'services/documentService';
import type { SWRResponse } from 'swr';
import useSWR from 'swr';

type SWRDocumentsData = Awaited<
  ReturnType<typeof documentService.getAvailableGroupedDocumentsAsync>
>;

const useAvailableGroupedDocuments = (
  load = true
): SWRResponse<SWRDocumentsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_DOCUMENTS_ENDPOINT] : null,
    async ([_]) => await documentService.getAvailableGroupedDocumentsAsync()
  );

export const SWR_DOCUMENTS_ENDPOINT = 'available-grouped-documents';
export default useAvailableGroupedDocuments;
